import {
  CHAT_WELL_DONE,
  RECEIVE_BOT_DONE,
  RECEIVE_BOT_MESSAGE,
  RECEIVE_BOT_STATE,
  SEND_CHAT_MESSAGE,
  RESET_MESSAGES,
  UPDATE_CHAT_SKILLS
} from "../actions/types";
import _ from "lodash";

export const chatReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_CHAT_MESSAGE:
      return {
        ...state,
        messages: [action.messages, ...(state.messages || [])],
        isTyping: true,
        disableInput: action.disableInput,
      };
    case RESET_MESSAGES:
      return {
        messages: [],
        isTyping: false,
        disableInput: true,
        showWellDone : state.showWellDone
      };
    case RECEIVE_BOT_MESSAGE:
      return {
        ...state,
        isTyping: action.messages.typing || false,
        messages: [action.messages, ...(state.messages || [])],
        disableInput: action.disableInput || state.showWellDone,
      };
    case RECEIVE_BOT_DONE:
      return {
        ...state,
        showWellDone: true,
        disableInput: true,
      };

    case UPDATE_CHAT_SKILLS:
      let USERnewOccupationSkills = action.newOccupationSkills;
      const newOccIdx = action.skillObjIdx;
      let newOccupationSkills = state.occupationSkills;
      let newSkillsNumber = state.skillsNumber;
      
      if (USERnewOccupationSkills[newOccIdx].skills.length) {
        newSkillsNumber += USERnewOccupationSkills[newOccIdx].skills.length;
        USERnewOccupationSkills[newOccIdx].skills = USERnewOccupationSkills[newOccIdx].skills.map((item) => {
          return item.name.charAt(0).toUpperCase() + item.name.slice(1);
        })
      

        if (newOccIdx === newOccupationSkills.length){
          newOccupationSkills.push(USERnewOccupationSkills[newOccIdx])
        }
        else{
          newSkillsNumber -= newOccupationSkills[newOccIdx].skills.length;
          newOccupationSkills[newOccIdx] = USERnewOccupationSkills[newOccIdx]
        }
      }
      return {
        ...state,
        occupationSkills: newOccupationSkills,
        skillsNumber: newSkillsNumber
      };

    case RECEIVE_BOT_STATE:
      const {
        header = "",
        progress,
        ui_event = [],
        assesmentResult = {},
        occupationsData = {},
      } = action.payload;

      const {
        interests: {
          salary = [],
          locationRadius = [],
          locationOriginal = [],
          contract: contractype = [],
          jobTypes = []
        } = {},
        results: {
          interests = {},
          styles = {}
        }
      } = assesmentResult;
      /*eslint-enable */
      
      const {
        desiredOccupationsOriginal = [],
        occupationsOriginal = [],
        occupationSkills = [],
        desiredExp = [],
        qualifications,
        candidate_status_history = [],
        allow_reverse_mine =  true,
        internalMobilityRoleDetails,
        internalMobilityLocationDetails
      } = occupationsData;

      var skillsNumber = 0;

      var ocSkills = occupationSkills;

      if (ocSkills.length) {
        ocSkills.forEach((item) => {
          if (item.skills) {
            skillsNumber += item.skills.length;
            var arr = [];

            item.skills.forEach((elem) => {
              arr.push(elem.name.charAt(0).toUpperCase() + elem.name.slice(1));
            });
            item.skills = arr;
          }
        });
      }

      const styles_scale = 5
      const interests_scale = interests ? _.sum(Object.entries(interests).map(([key, value]) => Number(value))) : false
      const stylesGraphData = styles ? Object.entries(styles).map(([key, value]) => {
        return {
          name: key,
          You: Math.round((value / styles_scale) * 100, 2),
        }
      }) : [];

      const interestsGraphData = (interests && interests_scale) ? Object.entries(interests).map(([key, value]) => {
        return {
          id: key,
          label: key,
          value: Math.round((value / interests_scale) * 100, 2),
        }
      }) : [];

      const [_salary] = salary;
      const [_contractype] = contractype;
      const [_travel] = locationRadius;
      const [_location] = locationOriginal;

      var prevOcc = [] 
      for (const idx in desiredExp) {
        if (desiredExp[idx]){
          prevOcc.push(desiredOccupationsOriginal[idx])
        }
      }
      prevOcc.push(...occupationsOriginal);
      
      let candidateStatus = "Status not entered"
      if (candidate_status_history && candidate_status_history.length > 0){
        candidateStatus = candidate_status_history[candidate_status_history.length -1].status
      }

      return {
        ...state,
        progress,
        header,
        ui_event,
        salary: _salary === "0" ? "No Preference" : _salary,
        travelToWork: _travel,
        contractType: _contractype,
        jobTypes: jobTypes && jobTypes.length > 0 ? jobTypes : [],
        location: _location,
        interestsGraphData,
        stylesGraphData,
        qualifications,
        skillsNumber,
        desiredExp,
        preferredOccupations: desiredOccupationsOriginal,
        previousOccupations: prevOcc,
        occupationSkills: ocSkills,
        candidateStatus,
        allow_reverse_mine,
        internalMobilityRoleDetails,
        internalMobilityLocationDetails
      };
    case CHAT_WELL_DONE:
      return {
        ...state,
        showWellDone: false,
      };
    default:
      return state;
  }
};
